import RequestHandler from "./request-handler";
class HeatingPeriodListService {
    constructor() {
        this.path = "HeatingPeriod";
        if (HeatingPeriodListService.instance) {
            return HeatingPeriodListService.instance;
        }
        HeatingPeriodListService.instance = this;
        return this;
    }
    async get() {
        return await RequestHandler.get(this.path);
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async update(data) {
        return RequestHandler.put(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
}
const instance = new HeatingPeriodListService();
export default instance;